import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";

const StyledLink = styled(Link)`
  text-decoration: none;
`;

const RouterLink = ({ className, children, href }) => (
  <StyledLink className={className} to={href}>
    {children}
  </StyledLink>
);

export default RouterLink;
